<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="mt-4">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text class="py-6">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-row class="mb-0 pb-0">
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider v-slot="{ errors }" name="descricao">
                      <v-text-field
                        v-model="contrato.descricao"
                        label="Descrição"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="gate"
                      rules="required"
                    >
                      <v-text-field
                        label="Gate/Unidade Destino"
                        disabled
                        :error-messages="errors"
                        :value="
                          contrato.gate
                            ? contrato.gate.trade_name
                            : empresaAtual.trade_name
                        "
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="fornecedor"
                    >
                      <v-autocomplete
                        v-if="isUnidadeGate"
                        label="Fornecedor"
                        required
                        :items="fornecedores"
                        v-model="contrato.fornecedor"
                        :item-text="getLabelEmpresa"
                        item-value="public_id"
                        return-object
                        :error-messages="errors"
                        :disabled="!isUnidadeGate"
                        :readonly="!isUnidadeGate"
                        @change="handleFornecedorSelecionado"
                      />
                      <v-text-field
                        v-else
                        label="Fornecedor"
                        disabled
                        :value="contrato.fornecedor?.trade_name || ''"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row class="mb-0 pb-0">
                  <v-col cols="12" sm="12" md="2">
                    <validation-provider
                      v-slot="{ errors }"
                      name="data_inicio"
                      rules="required"
                    >
                      <v-text-field
                        v-model="contrato.data_inicio"
                        label="Data Inicio"
                        required
                        :error-messages="errors"
                        type="date"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="2">
                    <validation-provider
                      v-slot="{ errors }"
                      name="data_fim"
                      rules="required"
                    >
                      <v-text-field
                        v-model="contrato.data_fim"
                        label="Data Fim"
                        required
                        :error-messages="errors"
                        type="date"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Tipo de Operação"
                      rules="required"
                    >
                      <v-autocomplete
                        label="Tipo de Operação"
                        item-text="descricao"
                        required
                        item-value="id"
                        :items="tiposOperacao"
                        v-model="contrato.tipo_operacao"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider v-slot="{ errors }" name="navio">
                      <v-autocomplete
                        label="Navio"
                        :items="naviosComOpcaoNenhum"
                        v-model="contrato.navio"
                        item-text="descricao"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row class="mb-0 pb-0">
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="numero_documento"
                    >
                      <v-text-field
                        v-model="contrato.numero_documento"
                        label="Nº do documento"
                        title="Número do documento"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="produto"
                    >
                      <v-autocomplete
                        label="Produto"
                        :items="produtos"
                        v-model="contrato.produto"
                        item-text="descricao"
                        item-value="id"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="sub produto"
                    >
                      <v-autocomplete
                        label="Sub Produto"
                        :items="subProdutos"
                        v-model="contrato.subProduto"
                        item-text="descricao"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-autocomplete
                      label="Cliente"
                      :items="clientes"
                      v-model="contrato.cliente"
                      :item-text="getLabelEmpresa"
                      item-value="public_id"
                      return-object
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="terminal"
                      rules="required"
                    >
                      <v-autocomplete
                        label="Terminal"
                        required
                        :items="terminais"
                        v-model="contrato.terminal"
                        :item-text="getLabelEmpresa"
                        :error-messages="errors"
                        item-value="public_id"
                        return-object
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      type="number"
                      label="Quantidade (Ton)"
                      v-model="contrato.qt_peso"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <buttons-cadastro @close="close" @save="save" :disabled="invalid" />
        </v-card-actions>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ButtonsCadastro from '../../ButtonsCadastro/ButtonsCadastro.vue'
import GateAPI from '@/services/tenants/gates'
import Perfil from '@/utils/perfil'
import ContratoAPI from '@/services/tenants/contratos'
import moment from 'moment'

export default {
  name: 'EditarContrato',

  components: { ButtonsCadastro },

  props: {
    contratoASerEditado: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      overlay: false,
      produtos: [],
      subProdutos: [],
      navios: [],
      terminais: [],
      gates: [],
      contrato: {
        public_id: '',
        numero_documento: '',
        descricao: '',
        data_inicio: '',
        data_fim: '',
        fornecedor: null,
        navio: null,
        gate: null,
        cliente: null,
        terminal: null,
        tipo_operacao: null,
        qt_peso: 0,
      },
    }
  },

  computed: {
    ...mapState('patio', ['tiposOperacao']),
    ...mapState('fornecedores', ['fornecedores']),
    ...mapState('clientes', ['clientes']),
    ...mapState('auth', ['empresaAtual', 'perfilAtual']),

    isUnidadeGate() {
      return this.empresaAtual.gate && this.perfilAtual == Perfil.Unidade
    },
    naviosComOpcaoNenhum() {
      return [{ descricao: 'Nenhum', id: null }, ...this.navios]
    },
    gateId() {
      return this.empresaAtual.gate?.public_id || this.empresaAtual.public_id
    },
  },

  async created() {
    this.overlay = true
    try {
      await Promise.all([
        this.getFornecedores(),
        this.getTipoOperacao(),
        this.getClientes(),
        GateAPI.getByParams({
          fornecedor_tenant: this.empresaAtual.public_id,
        }).then((res) => {
          this.gates = res
        }),
        ContratoAPI.getContratos(this.gateId, {
          perfil: Perfil.Terminal,
        }).then((res) => {
          this.terminais = res
        }),
      ])

      if (this.contratoASerEditado?.public_id) {
        await this.setValoresIniciaisDoContrato(this.contratoASerEditado)
      }
    } catch (error) {
      console.error('Erro ao inicializar edição:', error)
    } finally {
      this.overlay = false
    }
  },

  methods: {
    ...mapActions('patio', ['getTipoOperacao', 'getNavios', 'editContrato']),
    ...mapActions('fornecedores', ['getFornecedores']),
    ...mapActions('clientes', ['getClientes']),
    ...mapActions('template', ['errorMessage', 'successMessage']),

    getLabelEmpresa(item) {
      if (!item) return ''
      return `${item.business_name} ${item.cnpj}`
    },

    findOptionByPublicId(options, value) {
      if (!value) return null

      const publicId =
        typeof value === 'object'
          ? value.public_id || value.fornecedor_id
          : value

      return (
        options.find(
          (option) =>
            String(option.public_id || option.fornecedor_id) === String(publicId)
        ) || (typeof value === 'object' ? value : null)
      )
    },

    findOptionById(options, value) {
      if (!value) return null

      const id = typeof value === 'object' ? value.id : value
      return options.find((option) => String(option.id) === String(id)) || null
    },

    addOptionIfMissing(options, value, key = 'public_id') {
      if (!value || typeof value !== 'object') return

      const valueId = value[key]
      const exists = options.some(
        (option) => String(option[key]) === String(valueId)
      )

      if (!exists) options.push(value)
    },

    async setOpcoesDoFornecedor(fornecedor) {
      if (!fornecedor) return

      const tenantId = fornecedor.fornecedor_id || fornecedor.public_id

      if (!tenantId) return

      this.navios = await this.getNavios({ tenant: tenantId })
      this.produtos = fornecedor.produtos || []
    },

    async setValoresIniciaisDoContrato(contrato) {
      const {
        fornecedor,
        gate,
        navio,
        sub_produto,
        data_inicio,
        data_fim,
        tipo_operacao,
      } = contrato

      const fornecedorSelecionado = this.fornecedores.find(
        (f) =>
          f.public_id ===
          (typeof fornecedor === 'object'
            ? fornecedor.public_id || fornecedor.fornecedor_id
            : fornecedor)
      )

      const fornecedorDoContrato = fornecedorSelecionado || fornecedor
      const fornecedorComOpcoes = {
        ...(typeof fornecedor === 'object' ? fornecedor : {}),
        ...(fornecedorSelecionado || {}),
        produtos: fornecedorSelecionado?.produtos || fornecedor?.produtos || [],
      }
      await this.setOpcoesDoFornecedor(fornecedorComOpcoes)

      this.addOptionIfMissing(this.gates, gate)
      this.addOptionIfMissing(this.terminais, contrato.terminal)
      this.addOptionIfMissing(this.navios, navio, 'id')

      const produto =
        this.findOptionById(this.produtos, contrato.produto) ||
        (typeof contrato.produto === 'object' ? contrato.produto : null)

      this.addOptionIfMissing(this.produtos, produto, 'id')
      this.addOptionIfMissing(produto?.subprodutos || [], sub_produto, 'id')

      this.contrato = {
        ...contrato,
        fornecedor: fornecedorDoContrato,
        gate: this.findOptionByPublicId(this.gates, gate),
        cliente: this.findOptionByPublicId(this.clientes, contrato.cliente),
        terminal: this.findOptionByPublicId(this.terminais, contrato.terminal),
        tipo_operacao: tipo_operacao?.id || tipo_operacao,
        navio: this.findOptionById(this.navios, navio),
        produto,
        subProduto: this.findOptionById(produto?.subprodutos || [], sub_produto),
        data_inicio: moment(data_inicio).utc().format('YYYY-MM-DD'),
        data_fim: moment(data_fim).utc().format('YYYY-MM-DD'),
      }
    },

    async handleFornecedorSelecionado(fornecedor) {
      if (!fornecedor) return
      await this.setOpcoesDoFornecedor(fornecedor)
    },

    async save() {
      const isValid = await this.$refs.observer.validate()

      if (isValid) {
        this.overlay = true
        const data = {
          public_id: this.contrato.public_id,
          numero_documento: this.contrato.numero_documento,
          descricao: this.contrato.descricao,
          data_inicio: moment(this.contrato.data_inicio)
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss'),
          data_fim: moment(this.contrato.data_fim)
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss'),
          fornecedor: this.contrato.fornecedor?.public_id ?? null,
          cliente: this.contrato.cliente?.public_id ?? null,
          terminal: this.contrato.terminal?.public_id ?? null,
          proprietario: this.empresaAtual.public_id,
          gate: this.contrato.gate?.public_id ?? null,
          produto: this.contrato.produto?.id ?? null,
          sub_produto: this.contrato.subProduto?.id ?? null,
          navio: this.contrato.navio?.id ?? null,
          qt_peso: this.contrato.qt_peso ?? 0,
          tipo_operacao: this.contrato.tipo_operacao,
          active: true,
        }

        try {
          await this.editContrato(data)
          this.successMessage('Contrato editado com sucesso!')
          this.$emit('close')
        } catch (error) {
          this.errorMessage('Erro ao editar contrato.')
          console.error('Erro ao editar contrato:', error)
        } finally {
          this.overlay = false
        }
      }
    },

    close() {
      this.$emit('close')
    },
  },

  watch: {
    'contrato.produto': {
      handler(produto) {
        this.subProdutos = produto?.subprodutos || []
      },
      immediate: true,
    },
  },
}
</script>